<template>
  <div class="component">
    <div class="steps">
      <span class="steps-item" :class="{ active: activeStep === 0 }"></span>
      <span class="steps-item" :class="{ active: activeStep === 1 }"></span>
      <span class="steps-item" :class="{ active: activeStep === 2 }"></span>
      <span class="steps-item" :class="{ active: activeStep === 3 }"></span>
      <span class="steps-item" :class="{ active: activeStep === 4 }"></span>
      <span class="steps-item" :class="{ active: activeStep === 5 }"></span>
    </div>
    <div class="title">
      {{ title }}
    </div>
  </div>
</template>

<script>
export default {
  name: "StepsRow",
  props: ["title", "activeStep"]
};
</script>

<style scoped lang="scss">
@import "../../styles/colors";

.title {
  color: $blue;
  font-size: 27px;
  margin-top: 36px;
  text-align: center;
  font-family: TTNormsBold, sans-serif;
}
.steps {
  display: flex;
  justify-content: center;
}
.steps-item {
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: $blue;
  display: block;
  margin: 0 13px;
}
.steps-item.active {
  background-color: $green;
}
</style>
